export const waitForReactUpdate = () =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, 0);
  });

export default waitForReactUpdate;
